import { Building2, History, LifeBuoy } from 'lucide-react';

import { defineTour } from '@nucleus-commerce/admin-kit/tour';

import { MANAGE } from './manage';
import { organizationForDetail } from './resolvers';

export const platformOrganizationDetailTour = defineTour({
  id: 'platform.organizations.detail',
  version: 1,
  group: 'organisations',
  route: '/_authed/organizations/$organizationId',
  scope: 'record',
  resolve: organizationForDetail,
  icon: Building2,
  steps: [
    { id: 'profile', kind: 'explain', target: 'platform.organizations.profile' },
    { id: 'owners', kind: 'explain', target: 'platform.organizations.owners', placement: 'left' },
    { id: 'usage', kind: 'explain', target: 'platform.organizations.usage' },
    { id: 'export', kind: 'explain', target: 'platform.organizations.export' },
    { id: 'activity', kind: 'explain', target: 'platform.organizations.activity' },
    { id: 'stores', kind: 'explain', target: 'platform.organizations.stores', placement: 'top' },
  ],
  related: ['platform.organizations.detail-actions', 'platform.audit-log'],
});

/** Every step here changes something, so the chapter is for owners and admins only. */
export const platformOrganizationActionsTour = defineTour({
  id: 'platform.organizations.detail-actions',
  version: 1,
  group: 'organisations',
  route: '/_authed/organizations/$organizationId',
  scope: 'record',
  resolve: organizationForDetail,
  requires: MANAGE,
  icon: LifeBuoy,
  steps: [
    {
      id: 'edit',
      kind: 'explain',
      target: 'platform.organizations.edit',
      optional: true,
      waitMs: 1000,
    },
    {
      id: 'start-support',
      kind: 'explain',
      target: 'platform.organizations.start-support',
      optional: true,
      waitMs: 1000,
    },
    {
      id: 'lifecycle',
      kind: 'explain',
      variants: [
        { target: 'platform.organizations.suspend' },
        { target: 'platform.organizations.reactivate', copy: 'reactivate' },
        { target: 'platform.organizations.reopen', copy: 'reopen' },
      ],
      optional: true,
      waitMs: 1000,
    },
    {
      id: 'sessions',
      kind: 'explain',
      target: 'platform.organizations.sessions',
      placement: 'top',
    },
  ],
  related: ['platform.support-sessions', 'platform.organizations.detail'],
});

export const platformSupportSessionsTour = defineTour({
  id: 'platform.support-sessions',
  version: 1,
  group: 'organisations',
  route: '/_authed/support-sessions',
  scope: 'org',
  icon: LifeBuoy,
  steps: [
    { id: 'table', kind: 'explain', target: 'platform.support-sessions.table' },
    { id: 'show-ended', kind: 'explain', target: 'platform.support-sessions.show-ended' },
    {
      id: 'end',
      kind: 'explain',
      target: 'platform.support-sessions.end',
      requires: MANAGE,
      optional: true,
      waitMs: 1000,
    },
  ],
  related: ['platform.organizations.detail', 'platform.audit-log'],
});

export const platformAuditLogTour = defineTour({
  id: 'platform.audit-log',
  version: 1,
  group: 'organisations',
  route: '/_authed/audit-log',
  scope: 'org',
  icon: History,
  steps: [
    { id: 'filters', kind: 'explain', target: 'platform.audit-log.filters' },
    { id: 'table', kind: 'explain', target: 'platform.audit-log.table', placement: 'top' },
    {
      id: 'row-details',
      kind: 'action',
      target: 'platform.audit-log.row-details',
      optional: true,
      waitMs: 1500,
    },
  ],
  related: ['platform.support-sessions'],
});
